import { RichText } from '@/components/shared/rich-text'
import { SectionHeader } from '@/components/shared/section-header'
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion'
import { BlokProps } from '@/lib/types'
import { ContentMediaStoryblok } from '@/lib/types/component-types-sb'
import { cn } from '@/lib/utils'
import { storyblokEditable } from '@storyblok/react/rsc'
import { StoryblokImage } from '../shared/storyblok-image'

export function ContentMedia({ blok }: BlokProps<ContentMediaStoryblok>) {
  const layout = blok.layout ?? 'media-left'

  return (
    <section
      {...storyblokEditable(blok)}
      className="border-border divide-border relative border-y"
    >
      <div className="page-container relative z-5">
        <div className="grid grid-cols-1 items-center lg:min-h-[500px] lg:grid-cols-2 lg:gap-32">
          <div
            className={cn({
              'py-24 lg:py-12': true,
              'lg:order-last': layout === 'media-right',
            })}
          >
            {blok.visualMedia && (
              <StoryblokImage
                image={blok.visualMedia}
                className={cn(
                  'h-auto w-full',
                  blok.staticImage && 'border-border rounded-md border lg:my-12',
                )}
              />
            )}
          </div>
          <div className="space-y-2.5 py-12 lg:py-12">
            <SectionHeader
              icon={blok.descriptorIcon}
              title={blok.title}
              preTitle={blok.descriptorTitle}
            ></SectionHeader>
            <RichText content={blok.content}></RichText>
            {blok.accordion && blok.accordion.length > 0 && (
              <Accordion
                type="single"
                collapsible
                className="w-full"
              >
                {blok.accordion.map((item, index) => (
                  <AccordionItem
                    key={index}
                    value={item._uid}
                    title={blok.title}
                  >
                    <AccordionTrigger>{item.title}</AccordionTrigger>
                    <AccordionContent>
                      <RichText content={item.content}></RichText>
                    </AccordionContent>
                  </AccordionItem>
                ))}
              </Accordion>
            )}
          </div>
        </div>
      </div>
    </section>
  )
}
